<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="2" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>修改密码</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="px-6">
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:18'"
          type="password" 
          label="旧密码" 
          name="old_password" 
          v-model="oldPassword" 
          class="mt-5 w-full" />
        <span class="text-danger text-sm">{{ errors.first('old_password') }}</span>
        <vs-input 
          ref="new_password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:18'"
          type="password" 
          label="新密码" 
          name="new_password" 
          v-model="newPassword" 
          class="mt-5 w-full" />
        <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>
        <vs-input 
          v-validate="'min:6|max:18|confirmed:new_password'"
          data-vv-validate-on="blur"
          data-vv-as="new_password"
          type="password" 
          label="重复新密码" 
          name="confirm_password" 
          v-model="confirmPassword" 
          class="mt-5 w-full" />
          <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="addData" :disabled="!validateForm">提交修改</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">取消</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>

import { Validator } from 'vee-validate'
import { resetPassword } from '@/api/user'
import { getToken, clearToken } from '@/utils/tools';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

const dict = {
    custom: {
        old_password: {
            required: '请输入原密码',
            min: '旧密码不能小于6'
        },
        new_password: {
            required: '请输入新密码',
            min: '密码的长度小于6',
            max: '密码的长度不能大于18'
        },
        confirm_password: {
            confirmed: '两次输入的密码不一致',
            min: '密码的长度小于6',
            max: '密码的长度不能大于18'
        }
    }
}

Validator.localize('zh', dict)

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    model: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
        }
      }
    },
    validateForm() {
        return !this.errors.any() && this.oldPassword != '' && this.newPassword != '' && this.confirmPassword != '';
    }
  },
  created() {
  },
  methods: {
    addData() {
      let that = this
      if (!that.validateForm) return false
      resetPassword({
        access_token: getToken(),
        password: that.oldPassword,
        new_password: that.newPassword,
      }).then(res => {
        if (res.data.err_code === 0) {
          this.$vs.notify({
          title:'成功',
          text: '修改成功，请重新登录～',
          color:'success',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
          setTimeout(function() {
            if (that.$auth.profile) that.$auth.logOut();
              that.$router.push('/pages/login')
              localStorage.removeItem('userInfo');
              clearToken()
              that.$acl.change('admin')
              localStorage.removeItem('userRole');
          }, 1500)
          that.$emit('closeSidebar', true);
        }
        
      })
    },
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.default-avatar:hover {
  cursor: pointer;
  border-radius: 6px;
  box-shadow: 1px 1px 10px #eee;
}
</style>
